module.exports = __webpack_public_path__ + "img/singlelayout.caab5263.svg";